import React from 'react';
import { getFontColor } from '../../color-settings/components/color-parser';
import { VisitCardLine } from './types';

import styles from './VisitCard.module.scss';

interface VisitCardProps {
  color: string;
  content: VisitCardLine[];
  appointmentId?: number | string;
}

const VisitCard: React.FC<VisitCardProps> = React.memo(function VisitCard(
  props,
) {
  const { content, color, appointmentId } = props;

  return (
    <div
      data-test-id={'calendar-appointment'}
      data-appointment-id={appointmentId}
      className={styles.container}
      style={{
        background: color,
        borderLeftColor: getFontColor(color),
        color: getFontColor(color),
      }}
    >
      {content.map((line, index) => (
        <div
          key={index}
          style={{ ...line.style, lineHeight: line.style.fontSize }}
        >
          {line.value}
        </div>
      ))}
    </div>
  );
});

export default VisitCard;
